module.exports = __webpack_public_path__ + "img/hr-centrifuge-A-light.3cb873b2.png";